import _ from 'lodash';
import moment from 'moment-timezone'
import ReservationUtil from '@/utils/reservation-util'

const isReservationModuleActive = (state) =>{
  return true;
}

const getCustomerReservationsByDate = (state) =>{
  return _.groupBy(state.customerReservations,"date")
}

const getCustomerReservationsByProduct = (state) =>{
  return _.groupBy(state.customerReservations, "product.name")
}

const getActiveCustomerReservations = (state) => {
  return _.filter(state.customerReservations, r => r.completed == false);
}

const isFiltered = (state)=>{
  if(state.filters.active==true || state.filters.inactive==true ||
     state.filters.redFlag==true || state.filters.yellowFlag==true ||
     state.filters.greenFlag==true || state.filters.delayed==true || state.filters.salesRep.length>0){
       return true;
     }else{
       return false;
     }
}

const isActive = (state) => (reservation) =>{
  if((reservation.quantity.qty_available > 0 && reservation.delayed == false && reservation.intent == false && reservation.expired == false) ||
     (reservation.quantity.qty_available == 0 && (reservation.delayed == true || reservation.intent == true) && reservation.expired == false)){
       return true;
     }else{
       return false;
     }
}

const getOrderBy = (state) =>{
  return state.orderBy;
}

const getSortIcon = (state) =>{
  return state.sort_icon;
}

const selectedReservationlimitDate = (state)=>{
  if(localStorage.RESERVATION_CONFIGURATION!=null && state.selectedReservation!=null && state.selectedReservation.date != null){
    let limitDate = moment(state.selectedReservation.date).add(moment.duration(JSON.parse(localStorage.RESERVATION_CONFIGURATION).maximum_age),'days');
    return limitDate.format();
  }else{
    return null;
  }
}

const isNegative = (state)=>(nbDays)=>{
  let red_flag_threshold = moment.duration('P25D').asDays();
    return red_flag_threshold<=nbDays;

}

const isIntermediary = (state)=>(nbDays)=>{
  let yellow_flag_threshold = moment.duration('P15D').asDays();
    let red_flag_threshold = moment.duration('P25D').asDays();
    return yellow_flag_threshold<=nbDays;
}

const isPositive = (state)=>(nbDays)=>{
   let yellow_flag_threshold = moment.duration('P15D').asDays();
    return yellow_flag_threshold>nbDays;
}

const customerName = (state) => (customer) =>{
  if(customer==null)return null;
  return customer.usual_name!=null?customer.usual_name:customer.name;
}

const isQuantityValid = (state) => (index) =>{
  let reservation = index!=null ? state.reservations[index] : state.selectedReservation;
  return ReservationUtil.isQuantityValid(reservation);
}

export default {
  getActiveCustomerReservations,
  getCustomerReservationsByDate,
  getCustomerReservationsByProduct,
  getOrderBy,
  getSortIcon,
  isNegative,
  isIntermediary,
  isPositive,
  isReservationModuleActive,
  selectedReservationlimitDate,
  isActive,
  isFiltered,
  customerName,
  isQuantityValid
};
